import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { supabase, isDemoMode } from '../lib/supabase'
import { buildContext, render } from '../lib/orderTemplates'
import { applyBrand } from '../lib/brand'

// Public, no-auth page rendered when a customer follows the
// "View this order online" link in their order email.
export default function OrderClientView() {
  const { token } = useParams()
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (isDemoMode) {
      setError('This view requires Supabase to be configured.')
      return
    }
    supabase.rpc('get_order_view', { p_token: token })
      .then(({ data, error }) => {
        if (error) return setError(error.message)
        if (!data) return setError('Order not found.')
        setData(data)
        if (data.brand) applyBrand(data.brand)
      })
  }, [token])

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4 bg-gray-50">
        <div className="card max-w-sm text-center">
          <h2 className="font-semibold text-gray-800 mb-2">We couldn't load this order.</h2>
          <p className="text-sm text-gray-600">{error}</p>
        </div>
      </div>
    )
  }
  if (!data) {
    return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading…</div>
  }

  const ctx = buildContext({
    order: data.order,
    company: data.company,
    brand: data.brand,
    lines: data.lines,
    formHtml: '',
  })
  const html = render(data.form_template || '<p>No form template configured.</p>', ctx)

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        {data.brand?.logo_url && (
          <div className="mb-6 text-center">
            <img src={data.brand.logo_url} alt={data.brand.name || ''} className="inline-block max-h-16" />
          </div>
        )}
        <div className="card">
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </div>
        <p className="text-center text-xs text-gray-400 mt-6">
          Powered by {data.brand?.name || 'WG Order Platform'}
        </p>
      </div>
    </div>
  )
}
